import { DateFormatType, MarketplaceType } from '@/Enums';
import moment from 'moment/moment';
import { dateTimeUtils } from '@/Utils';
import { Moment } from 'moment';

const isSpecialMarketplace = (marketplaceType: MarketplaceType): boolean => {
  return [MarketplaceType.Manual, MarketplaceType.Market].includes(marketplaceType);
};

const isMarketplaceWithoutApi = (marketplaceType: MarketplaceType) => {
  const withoutCallback = [MarketplaceType.Ozon, MarketplaceType.Kaufland];
  return withoutCallback.includes(marketplaceType);
};

const getSynchronizeFromMinDate = (syncDate?: string, marketplaceType?: MarketplaceType) => {
  if (!syncDate) {
    return dateTimeUtils.toFormattedString(new Date(), DateFormatType.LOCAL_DATE_TIME);
  }

  const insideRange = isAllowedSynchronizeRange(syncDate, marketplaceType);
  return insideRange ? dateTimeUtils.utcStringToLocalString(syncDate) : '';
}; // getSynchronizeFromMinDate

const isAllowedSynchronizeRange = (utcDate: string, marketplaceType?: MarketplaceType) => {
  const syncRange = getSynchronizeRangeByType(marketplaceType);
  return moment.utc(utcDate, DateFormatType.SERVER_DATE_TIME).isAfter(syncRange);
};

const getSynchronizeRangeByType = (marketplaceType?: MarketplaceType) => {
  let syncRange: Moment;

  switch (marketplaceType) {
    case MarketplaceType.Amazon: {
      syncRange = moment().subtract(2, 'years').startOf('day');
      break;
    }
    case MarketplaceType.Ebay: {
      syncRange = moment().subtract(90, 'days').startOf('day');
      break;
    }
    case MarketplaceType.Kaufland: {
      syncRange = moment().subtract(1, 'years').startOf('day');
      break;
    }
    default: {
      syncRange = moment().startOf('day');
      break;
    }
  }

  return syncRange;
};

export const mpAccountUtils = {
  isSpecialMarketplace,
  isMarketplaceWithoutApi,
  isAllowedSynchronizeRange,
  getSynchronizeFromMinDate,
  getSynchronizeRangeByType,
};
